import React, { useEffect, useState, useCallback } from "react";
import { useLocation, NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavList from "examples/Sidenav/SidenavList";
import SidenavItem from "examples/Sidenav/SidenavItem";
import SidenavCard from "examples/Sidenav/SidenavCard";
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";
import { useSoftUIController, setMiniSidenav } from "context";
import IconButton from "@mui/material/IconButton";
import { useAuth } from "../../auth-context/auth.context";
import { useNavigate } from "react-router-dom";
import { navbarIconButton } from "examples/Navbars/DashboardNavbar/styles";
import AuthApi from "../../api/auth";

function Sidenav({ absolute, light, isMini, color, brand, brandName, routes, userRole, userDashboardAccess, ...rest }) {
  const [openCollapse, setOpenCollapse] = useState(false);
  const [openNestedCollapse, setOpenNestedCollapse] = useState(false);
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentSidenav } = controller;
  const location = useLocation();
  const { pathname } = location;
  const collapseName = pathname.split("/").slice(1)[0];
  const itemName = pathname.split("/").slice(1)[1];
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  
 console.log(rest)
 console.log("rest-----")
 console.log(userRole)
 console.log("role-----")
 console.log(userDashboardAccess)

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
    navigate("/authentication/sign-in");
  };

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  useEffect(() => {
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
    }

    window.addEventListener("resize", handleMiniSidenav);
    handleMiniSidenav();

    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);

  
  
  const renderNestedCollapse = (collapse) =>
    collapse
      .filter(({ requireDashboardsAccess }) => {
        // If access is required, only allow if user has it
        if (requireDashboardsAccess && !user?.Dashboards_access) return false;
        return true;
      })
      .map(({ name, route, key, href, icon }) =>
        href ? (
          <Link
            key={key}
            href={href}
            target="_blank"
            rel="noreferrer"
            sx={{ textDecoration: "none" }}
          >
            <SidenavItem name={name} nested />
          </Link>
        ) : (
          <NavLink to={route} key={key} sx={{ textDecoration: "none" }}>
            <SidenavItem name={name} active={route === pathname} nested />
          </NavLink>
        )
      );

  const renderCollapse = (collapses) =>
    collapses.map(({ name, collapse, route, href, key, icon, requireadmin ,requireDashboardsAccess }) => {
      let returnValue;

      if (collapse) {
        returnValue = (
          <SidenavItem
            key={key}
            name={name}
            icon={icon}
            
            active={key === itemName}
            open={openNestedCollapse === name}
            onClick={() => (openNestedCollapse === name ? setOpenNestedCollapse(false) : setOpenNestedCollapse(name))}
          >
            {renderNestedCollapse(collapse)}
          </SidenavItem>
        );
      } else {
        returnValue = href ? (
          <Link href={href} key={key} target="_blank" rel="noreferrer" sx={{ textDecoration: "none" }}>
            <SidenavItem name={name} active={key === itemName} icon={icon} />
          </Link>
        ) : (
          <NavLink to={route} key={key} sx={{ textDecoration: "none" }}>
            <SidenavItem name={name} active={key === itemName} icon={icon} />
          </NavLink>
        );
      }

      return (
        (requireadmin && userRole !== "admin") ||
        (requireDashboardsAccess && !user?.Dashboards_access)
      ) ? null : <SidenavList key={key}>{returnValue}</SidenavList>;
    });

    const renderRoutes = routes.map(({ type, name, icon, title, collapse, noCollapse, key, href, route, requireadmin, requireDashboardsAccess }) => {
      let returnValue;
    
      // 🛑 Filter out route if user doesn't have access
      if (
        (requireadmin && userRole !== "admin") ||
        (requireDashboardsAccess && !user?.Dashboards_access)
      ) {
        return null;
      }
    
      if (type === "collapse") {
        if (href) {
          returnValue = (
            <Link
              href={href}
              key={key}
              icon={icon}
              target="_blank"
              rel="noreferrer"
              sx={{ textDecoration: "none" }}
            >
              <SidenavCollapse
                name={name}
                icon={icon}
                active={key === collapseName}
                noCollapse={noCollapse}
              />
            </Link>
          );
        } else if (noCollapse && route) {
          returnValue = (
            <NavLink to={route} key={key}>
              <SidenavCollapse
                name={name}
                icon={icon}
                noCollapse={noCollapse}
                active={key === collapseName}
              >
                {collapse ? renderCollapse(collapse) : null}
              </SidenavCollapse>
            </NavLink>
          );
        } else {
          returnValue = (
            <SidenavCollapse
              key={key}
              name={name}
              icon={icon}
              active={key === collapseName}
              open={openCollapse === key}
              onClick={() =>
                openCollapse === key ? setOpenCollapse(false) : setOpenCollapse(key)
              }
            >
              {collapse ? renderCollapse(collapse) : null}
            </SidenavCollapse>
          );
        }
      } else if (type === "title") {
        returnValue = (
          <SoftTypography
            key={key}
            display="block"
            variant="caption"
            fontWeight="bold"
            textTransform="uppercase"
            opacity={0.6}
            pl={3}
            mt={2}
            mb={1}
            ml={1}
          >
            {title}
          </SoftTypography>
        );
      } else if (type === "divider") {
        returnValue = <Divider key={key} />;
      } else if (type === "link") {
        returnValue = (
          <NavLink to={route} key={key} sx={{ textDecoration: "none" }}>
            <SidenavItem name={name} active={route === pathname} icon={icon} />
          </NavLink>
        );
      }
    
      return returnValue;
    });

  return (
    <SidenavRoot {...rest} variant="permanent" ownerState={{ transparentSidenav, miniSidenav }}>
      <SoftBox pt={3} pb={1} px={4} textAlign="center">
        <SoftBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <SoftTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>close</Icon>
          </SoftTypography>
        </SoftBox>
        <SoftBox component={NavLink} to="/" display="flex" alignItems="center">
          {brand && <SoftBox component="img" src={brand} alt="Soft UI Logo" width="2rem" />}
          <SoftBox
            width={!brandName && "100%"}
            sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
          >
            <SoftTypography component="h6" variant="button" fontWeight="medium">
              {brandName}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      </SoftBox>
      <Divider />
      <List>{renderRoutes}</List>

      <SoftBox pt={2} my={2} mx={2}>
        <SidenavCard />
        <IconButton
          size="small"
          color="inherit"
          sx={navbarIconButton}
          aria-controls="logout"
          aria-haspopup="true"
          variant="contained"
          onClick={handleLogout}>
            <SoftTypography
                variant="button"
                fontWeight="medium"
                color={light ? "white" : "dark"}
              >
                Sign Out
            </SoftTypography>
          </IconButton>
      </SoftBox>
      
    </SidenavRoot>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
